import { getCountries, getCountryCallingCode, getExampleNumber } from 'libphonenumber-js';
import metadata from 'libphonenumber-js/metadata.full.json';
import examples from 'libphonenumber-js/examples.mobile.json';

const displayNames =
  typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function'
    ? new Intl.DisplayNames(['en'], { type: 'region' })
    : null;

const countryOptions = getCountries()
  .map((code) => {
    const resolvedName = (displayNames && displayNames.of(code)) || code;
    const exampleNumber = getExampleNumber(code, examples, metadata);
    const example = exampleNumber ? exampleNumber.formatInternational() : null;
    return {
      code,
      name: resolvedName,
      dialCode: `+${getCountryCallingCode(code, metadata)}`,
      example,
    };
  })
  .sort((a, b) => {
    const nameA = a.name || a.code;
    const nameB = b.name || b.code;
    return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
  });

const countryMap = countryOptions.reduce((acc, country) => {
  acc[country.code] = country;
  return acc;
}, {});

export { countryOptions, countryMap };


